import './PrivacyPolicy.css';
import Header from './Components/Header';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-header-bg">
        <Header />
      </div>
      <div className="policy-wrapper">
        <h1>Privacy Policy</h1>

        <section>
          <h2>Introduction</h2>
          <p>Welcome to our Privacy Policy page. We value your privacy and are committed to protecting your personal data.</p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <ul>
            <li>Personal information (e.g., The city you choose for event preferences, email address, etc.)</li>
            <li>Usage data (e.g., site interactions, page visits, etc.)</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <ul>
            <li>To improve our website and services</li>
            <li>To communicate with you regarding updates or promotions</li>
            <li>To enhance your user experience</li>
          </ul>
        </section>

        <section>
          <h2>How We Protect Your Information</h2>
          <p>We take reasonable measures to protect your information, including secure storage and transmission methods.</p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You have the right to access, correct, or delete your personal data at any time.</p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page.</p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, feel free to contact us.</p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
